import { SvgIconProps } from './icon-props';

export default function Dining({ height = 32, width = 32 }: SvgIconProps) {
	return (
		<svg
			viewBox="0 0 32 32"
			version="1.2"
			baseProfile="tiny-ps"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
		>
			<path
				fillRule="evenodd"
				d="M6.57 1.5a.538.538 0 0 1 .41.17c.05.05.09.11.12.18.03.07.05.15.05.22v5.04h2.69V2.07c0-.15.06-.3.17-.4a.56.56 0 0 1 .4-.17c.15 0 .3.06.41.17.1.1.16.25.17.4v5.04h2.69V2.07c0-.15.06-.3.17-.4a.56.56 0 0 1 .4-.17c.15 0 .3.06.41.17.1.1.16.25.17.4v6.7c0 .53-.1 1.05-.29 1.55a4.37 4.37 0 0 1-2.05 2.33c-.47.25-.98.41-1.5.48l-.01 16.63c0 .15-.06.3-.16.4-.11.11-.26.17-.41.17a.56.56 0 0 1-.4-.17.544.544 0 0 1-.17-.4V13.12a4.31 4.31 0 0 1-1.5-.47 4.37 4.37 0 0 1-1.24-.98c-.35-.4-.63-.86-.81-1.35A4.4 4.4 0 0 1 6 8.76V2.07c0-.07.02-.15.04-.22.03-.07.08-.13.13-.18.05-.06.11-.1.18-.13a.57.57 0 0 1 .22-.04zm.58 7.26c0 .43.08.86.25 1.25.16.4.4.76.7 1.06.31.3.67.54 1.06.7.4.17.82.25 1.25.25.43 0 .86-.08 1.25-.25.4-.16.76-.4 1.06-.7.3-.3.54-.66.71-1.06.16-.39.25-.82.25-1.25v-.51H7.15v.51zm13.73 9.36c-.32 0-.58-.26-.58-.57V6.01c0-2.68 1.65-4.39 4.77-4.39h.36c.07-.01.15.01.22.04s.13.07.18.12c.05.05.1.12.13.19.02.07.04.14.04.22v27.74c0 .15-.06.3-.17.4a.56.56 0 0 1-.4.17c-.15 0-.3-.06-.41-.17-.1-.1-.16-.25-.17-.4V18.12h-3.97zm.57-12.11v10.97h3.4V2.76c-2.32.07-3.4 1.25-3.4 3.25z"
			/>
		</svg>
	);
}
